import React from 'react';
import PropTypes from 'prop-types';
// Components
import DonationFormHandler from '../donation-form-handler';
import Button from '../button';
import { VisuallyHidden } from '../styled/accessibility';
// Styles
import {
  Hero,
  ImageWrapper,
  Image,
  Title,
  Description,
  StyledContainer,
  StyledInputBox,
  StyledField,
  Wrapper,
  StyledDonationInput,
  StyledOwnAmountSubmit,
} from './styles';

/**
 * Donation Hero, with an Input box where the user can set the amount to donate
 */
const DonationHeroWithInputBox = ({ content }) => {
  const { heading, description, backgroundImage, defaultAmount } = content;

  return (
    <Hero>
      <ImageWrapper>
        <Image $image={backgroundImage} />
        <StyledContainer>
          <StyledInputBox>
            <Title>{heading}</Title>
            <Description>{description}</Description>
            <DonationFormHandler
              frequency="once"
              id="donation-hero-input"
              dataTracking={{
                donationImage: backgroundImage && backgroundImage.file.url,
                description,
                donationBespoke: true,
              }}
              defaultDonationValue={defaultAmount}
              render={({ setFieldValue, defaultValue }) => (
                <>
                  <VisuallyHidden as="label" htmlFor="amount-holder">
                    Donate now
                  </VisuallyHidden>
                  <Wrapper>
                    <StyledField name="amount-holder">
                      {({ meta, ...rest }) => (
                        <StyledDonationInput
                          $noMargin
                          $inline
                          placeholder={defaultValue.toString()}
                          {...rest}
                          id="amount-holder"
                          onChange={(e) =>
                            setFieldValue('amount-holder', e.target.value)
                          }
                        />
                      )}
                    </StyledField>
                    <StyledOwnAmountSubmit
                      as={Button}
                      bg="primary"
                      type="submit"
                    >
                      Donate now
                    </StyledOwnAmountSubmit>
                  </Wrapper>
                </>
              )}
            />
          </StyledInputBox>
        </StyledContainer>
      </ImageWrapper>
    </Hero>
  );
};

DonationHeroWithInputBox.propTypes = {
  content: PropTypes.shape({
    heading: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    backgroundImage: PropTypes.object.isRequired,
    defaultAmount: PropTypes.number,
  }),
};

export default DonationHeroWithInputBox;
